import { FC, createContext, useContext, useEffect, useState } from 'react';

const defaultState = {
  startToCollect: undefined,
  getChannelInfo: undefined,
  pushEvent: undefined,
  pushToSignUp: undefined,
  SensorsTrack: undefined,
};

declare global {
  interface Window {
    APP_ID: number;
  }
}
export interface IDataCollection {
  startToCollect?: (env?: string, opts?: any) => void | undefined;
  getChannelInfo?: () => void | undefined;
  pushEvent?: (ea?: string, ec?: string, el?: string) => void | undefined;
  pushToSignUp?: any;
  SensorsStart?: (option: any) => void | undefined;
  SensorsTrack?: (type: string, data?: any) => void | undefined;
}

export const DataCollectionContext =
  createContext<IDataCollection>(defaultState);
DataCollectionContext.displayName = 'DataCollectionContext';

export const DataCollectionProvider: FC<any> = ({ children }) => {
  const [dc, setDc] = useState<IDataCollection>(defaultState);

  // Load gtm library asynchrously
  const loadModule = async () => {
    const dc = await import('./data-collection');
    const {
      startToCollect,
      pushEvent,
      getChannelInfo,
      pushToSignUp,
      SensorsTrack,
      SensorsStart,
    } = dc;
    setDc({
      startToCollect,
      getChannelInfo: (getChannelInfo as any).default, // original method from 'by-data-pool'
      pushEvent: pushEvent.default, // original method from 'by-gtm'
      pushToSignUp,
      SensorsTrack,
      SensorsStart,
    });
  };

  // Click event handler while element with "data-gtm" attribute
  const clickHandler = (e: Event) => {
    const { dataset = {} } = (e.target || {}) as HTMLElement;
    const { gtm = '' } = dataset;
    if (gtm) {
      const gtmData = gtm.split(',');
      dc.pushEvent(...gtmData);
    }
  };

  useEffect(() => {
    loadModule();
  }, []);

  useEffect(() => {
    if (dc.pushEvent) {
      document.addEventListener('click', clickHandler);
      return () => {
        document.removeEventListener('click', clickHandler);
      };
    }
  }, [dc]);

  return (
    <DataCollectionContext.Provider value={dc}>
      {children}
    </DataCollectionContext.Provider>
  );
};

export const useCollectionData = () => {
  const data = useContext(DataCollectionContext);
  return data;
};
